
import Swal from "sweetalert2";
import React, { useEffect, useState } from "react";
import { EyeEmpty, EyeOff } from "iconoir-react";
import {
  FormControl,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
} from "@material-ui/core";
import Swalgeneral from "../../../Landing/General/Swalgeneral";
import { domain } from "../../../Urls/Services/Api_urls";
import Logonew from "../../../assets/LogoNew.webp";

export default function Respass() {
  const [password, setPasswords] = useState("");
  const [password2, setPasswords2] = useState("");
  const [url, seturl] = useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [showPassword1, setShowPassword1] = React.useState(false);
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const type = params.type;
  const token = params.token;
  let objeto,
    objeto1 = [];
  let mess = "";
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowPassword1 = () => setShowPassword1((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const urlpass = {
    unifiedSale: "/user/" + token + "/UnifiedSaleUser/",
    TRPSale: "/directv/" + token + "/change_password/",
  };

  useEffect(() => {
    seturl(domain + urlpass[type]);
  }, []);

  const Cambiocon = () => {
    if (password === password2) {
      const credentials = { password2, password };
      console.log(credentials);
      console.log(url);
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(credentials),
      }).then(async function (response) {
        objeto = response.text();
        objeto1 = Promise.resolve(objeto);
        if (response.status === 200) {
          Swal.fire({
            title: "Perfecto!",
            text: "Se cambio la contraseña exitosamente",
            icon: "success",
            showConfirmButton: false,
            timer: 3000,
          }).then(() => {
            window.location.href = "/Login";
          });
        } else if (response.status >= 400) {
          objeto1.then((result) => {
            const parsedObject = JSON.parse(result);
            const { msg } = parsedObject;
            for (let key in msg) {
              if (key !== "0") {
                if (msg.hasOwnProperty(key)) {
                  mess = `${key}: ${msg[key]}\n`;
                  break;
                }
              } else {
                mess = msg;
                break;
              }
            }
            Swalgeneral("Error", "error", mess);
          });
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Las contraseñas no son iguales",
        text: "Revisa tus contraseñas!",
      });
    }
  };

  return (
    <div>
      <body>
        <section className="derecha">
          <div className="shadow-md backdrop-blur-sm rounded-3xl bg-white/70 flex flex-col justify-center items-center p-4 ...  ">
            <a href="/" className="flex items-start  my-8 ">
            <img className="w-52" src={Logonew} alt="" />
            </a>
            <form>
              <FormControl>
                <InputLabel htmlFor="standard-adornment-password">
                  Contraseña*
                </InputLabel>
                <Input
                  id="standard-adornment-password"
                  type={showPassword ? "text" : "password"}
                  name="Nueva Contraseña"
                  required
                  variant="standard"
                  value={password2}
                  onChange={(e) => setPasswords2(e.target.value)}
                  style={{ width: "18rem" }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <EyeOff /> : <EyeEmpty />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
              </FormControl>
              <div style={{ height: 20 }} />
              <FormControl className="mt-8">
                <InputLabel htmlFor="standard-adornment-password">
                  Confirmar Contraseña*
                </InputLabel>
                <Input
                  type={showPassword1 ? "text" : "password"}
                  name="Confirmar Contraseña"
                  onChange={(e) => setPasswords(e.target.value)}
                  required
                  value={password}
                  variant="standard"
                  style={{ width: "18rem" }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword1}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword1 ? <EyeOff /> : <EyeEmpty />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
              </FormControl>
              <button className="w-[60%] mt-3 text-white rounded-xl bg-blue-500 hover:bg-blue-600 active:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-300 ..." onClick={Cambiocon} type="button">
                Confirmar
              </button>
            </form>
          </div>
        </section>
      </body>
    </div>
  );
}
